import _get from "lodash/get";
import "core-js/modules/es6.string.link.js";
import "core-js/modules/es6.object.keys.js";
import React from 'react';
import PropTypes from 'prop-types'; // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

import pick from 'lodash/pick'; // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

import values from 'lodash/values'; // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

import defaultsDeep from 'lodash/defaultsDeep';
import { ImpressionClick, Click } from '@nerdwallet/nw-client-lib/tracking';
import ApplyNowImpression from './apply-now-impression';
import LinkType from './link-type';
import FinishType from './finish-type';
import Monetizable from './monetizable';
/**
 * Returns a new object which contains props required for the `<Click />`
 * component, out of props picked from the supplied argument.
 *
 * This includes properties required for both the Click event as well as
 * BetaProductShoppingFinish event.
 *
 * @example
 * ```
 * // Use in a component like so
 * SomeComponent = props => <Click {...getClickProps(props)} />
 *
 * // The structure is as follows
 * {
 *   clickProp1,
 *   clickProp2,
 *   eventProps: {
 *     // properties which will be inserted into the apply-now URL query-string.
 *     // both for Click event and BetaProductShoppingFinish.
 *     // we will transform keys to snake case as appropriate.
 *   }
 * }
 * ```
 *
 * @param {Object} props -
 * @returns {Object} - Props for <Click />.
 */

var getClickProps = function getClickProps(props) {
  var additionalAttributes = props.additionalAttributes,
      ext_click_id = props.ext_click_id,
      finishType = props.finishType,
      hasPrequalified = props.hasPrequalified,
      impressionId = props.impressionId,
      link = props.link,
      linkType = props.linkType,
      logImpression = props.logImpression,
      monetizable = props.monetizable,
      pageNumber = props.pageNumber,
      productDisplayDriver = props.productDisplayDriver,
      productImpressionId = props.productImpressionId,
      productPosition = props.productPosition,
      referringUrl = props.referringUrl,
      sectionName = props.sectionName,
      sectionPosition = props.sectionPosition,
      shortButton = props.shortButton,
      prequalId = props.prequalId;
  var clickProps = pick(props, [// Props expected by tracking/Click
  'eventProps', 'pageViewId', // General purpose props
  'className', 'component', 'disabled', 'id', 'onClick', 'rel', 'primary', 'secondary', 'tertiary', 'newWindow', // eslint-disable-next-line camelcase
  ext_click_id ? 'ext_click_id' : '' // Used to identify performance marketing campaigns
  ]);
  clickProps.short = shortButton;
  clickProps.href = link;

  if (referringUrl) {
    clickProps.href = "".concat(link, "&url=").concat(referringUrl);
    clickProps.rel = 'nofollow noreferrer noopener';
  } // Assign clickHeader props if logImpression false
  // If logImpression is true, this is handled by ImpressionClick
  // https://github.com/NerdWallet/nw-client-lib/blob/643ceb47f02e969ef5a780e3f992a47e897071e0/src/tracking/components/impression-click.jsx#L20


  if (!logImpression) {
    var clickHeaderProps = pick(props, ['pageNumber', 'productPosition', 'productLocation', 'productInstance', 'sectionPosition', 'productId', 'productSlug', 'linkType']);
    clickProps.eventProps = defaultsDeep(clickProps.eventProps || {}, {
      clickHeader: clickHeaderProps
    });
  }
  /* Following events are required for the new flex event (BetaProductShoppingFinish)
     See https://github.com/NerdWallet/schemas/blob/master/protobuf/src/event/BetaProductShoppingFinish.proto#L51 */


  clickProps.eventProps = defaultsDeep(clickProps.eventProps || {}, {
    finish_type: finishType,
    has_prequalified: hasPrequalified,
    impression_id: impressionId,
    link_type: linkType,
    monetizable: monetizable,
    page_number: pageNumber,
    product_impression_id: productImpressionId,
    product_display_driver: productDisplayDriver,
    product_position: productPosition,
    section_name: sectionName,
    section_position: sectionPosition
  });

  if (prequalId) {
    clickProps.eventProps.prequal_id = prequalId;
  } // eslint-disable-next-line camelcase


  if (ext_click_id) {
    // eslint-disable-next-line camelcase
    clickProps.eventProps.ext_click_id = ext_click_id;
  }

  if (additionalAttributes) {
    clickProps.eventProps.additional_attributes = JSON.stringify(additionalAttributes);
  }

  return clickProps;
}; // Names of props required for the `<Impression />` component.
// eslint-disable-next-line react/forbid-foreign-prop-types -- directive added automatically by Shepherd migration


var impressionPropNames = Object.keys(ApplyNowImpression.propTypes).concat(['vertical', 'isCC', 'additionalEventData']); // for ProductImpression

/**
 * Picks props required for `<Impression />` and returns a new object which
 * can be spread in JSX.
 *
 * @example
 * ```
 * SomeComponent = props => <Impression {...getImpressionProps(props)} />
 * ```
 * @param {Object} props -
 * @returns {Object} - props required for `<Impression />`.
 */

var getImpressionProps = function getImpressionProps(props) {
  return pick(props, impressionPropNames);
};

var ApplyNowLink = function ApplyNowLink(props) {
  var logImpression = props.logImpression,
      children = props.children;
  var ApplyNowClickComponent = logImpression ? ImpressionClick : Click;
  return /*#__PURE__*/React.createElement(ApplyNowImpression, getImpressionProps(props), /*#__PURE__*/React.createElement(ApplyNowClickComponent, getClickProps(props), children));
};

ApplyNowLink.defaultProps = {
  additionalAttributes: null,
  children: null,
  className: null,
  component: null,
  ext_click_id: null,
  finishType: FinishType.EXTERNAL_APPLICATION,
  hasPrequalified: false,
  impressionId: null,
  isCC: false,
  linkType: null,
  logImpression: true,
  monetizable: null,
  newWindow: true,
  onClick: function onClick() {},
  pageNumber: null,
  prequalId: null,
  productDisplayDriver: null,
  productId: null,
  productImpressionId: null,
  productPosition: null,
  referringUrl: null,
  rel: 'nofollow',
  sectionName: null,
  sectionPosition: null,
  shortButton: false,
  vertical: _get(global, 'window.nwPageTaxonomy.vertical')
};
/* eslint-disable  react/forbid-prop-types */

ApplyNowLink.propTypes = {
  // An object containing extra properties for BetaProductShoppingFinish (which has a field called additional_attributes).
  additionalAttributes: PropTypes.object,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string,
  component: PropTypes.any,
  // BetaProductShoppingFinish:finish_type
  ext_click_id: PropTypes.string,
  finishType: PropTypes.oneOf(values(FinishType)),
  hasPrequalified: PropTypes.bool,
  // Used for impression identification. If there are multiple apply nows for the same product on a page, this should be unique for each one.
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  impressionId: PropTypes.string,
  // CC (credit-cards vertical) uses a cc-specific impression event. Set this to true for that behavior.
  isCC: PropTypes.bool,
  // The apply now link. obtained from the marketplace object.
  link: PropTypes.string.isRequired,
  // What type of control was the link on? See link-type.js for more info.
  linkType: PropTypes.oneOf(values(LinkType)),
  logImpression: PropTypes.bool,
  // Is this a monetizable link?
  monetizable: PropTypes.oneOf(values(Monetizable)),
  // If link should open in new window, this is true by default
  newWindow: PropTypes.bool,
  onClick: PropTypes.func,
  // For a multi-page interface (like cc tool), which page did this card appear on?
  pageNumber: PropTypes.number,
  prequalId: PropTypes.string,
  // Why was this card displayed to the user?
  productDisplayDriver: PropTypes.string,
  // The impression_id of the product impression that the user is selecting
  productImpressionId: PropTypes.string,
  // The ID of a financial product
  productId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  // For lists of card. Which position was this card at?
  productPosition: PropTypes.number,
  referringUrl: PropTypes.string,
  rel: PropTypes.string,
  // For a section interface (like BCC)
  sectionName: PropTypes.string,
  // Where was the section located on the page
  sectionPosition: PropTypes.number,
  // Renders a short button
  shortButton: PropTypes.bool,
  // The vertical to be used by the product impression
  vertical: PropTypes.string
};
/* eslint-enable */

export default ApplyNowLink;